import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule,Routes } from '@angular/router';
import { AuthInterceptor } from './Core/interceptor/auth-token.interceptor';
import { AppComponent } from './app.component';
import { LoginComponent } from './Features/auth/auth-module/Login/login.component';
import { ApiService } from './Core/services/api.services';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { GoogleChartsModule } from 'angular-google-charts';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { TimeZoneHoverComponent } from './Features/admin/admin-module/time-zone-hover/time-zone-hover.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; 
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ChartModule } from 'primeng/chart';


import { YesNoPipe, HumanTimePipe, TimeFormatPipe, GeoSizePipe, CamLightPipe, WeatherFilterPipe } from './Core/filters/common.filters';
import { UserSearchComponent } from './Features/admin/admin-module/user-search-ctl/user-search-ctl.component';
import { UserDetailComponent } from './Features/admin/admin-module/user-detail-ctl/user-detail-ctl.component';
import { DeviceListComponent } from './Features/admin/admin-module/device-list-ctl/device-list-ctl.component';
import { DeviceDetailCtlComponent } from './Features/admin/admin-module/device-detail-ctl/device-detail-ctl.component';
import { LogComponent } from './Features/admin/admin-module/log-ctl/log-ctl.component';
import { LocationDetailComponent } from './Features/admin/admin-module/location-detail-ctl/location-detail-ctl.component';
import { AlertCtlComponent } from './Features/admin/admin-module/alert-ctl/alert-ctl.component';
import { HumanTimeComponent } from './Core/Directives/human-time.directive';
import { EnterKeyComponent } from './Core/Directives/enter-key.directive';
import { ToolbarComponent } from './Core/components/Layout/toolbar/toolbar.component'; 
import { UserStatsComponent } from './Core/components/Layout/Panel/remotelync-stats/user-stats/user-stats.component';

import { DeviceConnectivityStatusComponent } from './Core/components/Layout/Panel/remotelync-stats/device-connectivity-status/device-connectivity-status.component';
import { WifiDetectorsComponent } from './Core/components/Layout/Panel/firmware-ver-dist/wifi-detectors/wifi-detectors.component';
import { CamerasComponent } from './Core/components/Layout/Panel/firmware-ver-dist/cameras/cameras.component';
import { HubsComponent } from './Core/components/Layout/Panel/firmware-ver-dist/hubs/hubs.component';
import { UserInfoAllComponent } from './Features/admin/admin-module/user-info-all/user-info-all.component';
import { UserDetailsDisplayComponent } from './Core/components/Layout/Panel/user-details-display/user-details-display.component';
import { LocationDisplayComponent } from './Core/components/Layout/Panel/location-display/location-display.component';
import { DevicesDisplayComponent } from './Core/components/Layout/Panel/devices-display/devices-display.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { AuthenticationInterceptor } from './Core/interceptor/error-handler.interceptor';
import {MatMenuModule} from '@angular/material/menu';
import { ChangePasswordComponent } from './Features/auth/auth-module/change-password/change-password.component';
import { FirmwareComponentComponent } from './Core/components/firmware.component/firmware.component.component';
import { LocationComponentComponent } from './Core/components/location-component/location-component.component';
import { DeviceDynamicComponent } from './Core/components/device-dynamic/device-dynamic.component';
import {KeysPipe} from './Core/utils/keys.pipe';
import { MembersPanelComponent } from './Core/components/members-panel/members-panel.component';
import { OtaModuleComponent } from './Features/admin/admin-module/ota-module/ota-module.component';
import { ListOTAComponent } from './Features/admin/admin-module/list-ota/list-ota.component';
import { OTAJobDetailComponent } from './Features/admin/admin-module/ota-job-detail/ota-job-detail.component';
import { MatFileUploadModule } from 'angular-material-fileupload';
import { SpinnerComponent } from './spinner/spinner.component';
import { LoadingDialogComponent } from './Core/components/loading-dialog/loading-dialog.component';
import { SuccessDialogComponent } from './Features/admin/admin-module/success-dialog/success-dialog.component';
import { DashboardComponent } from './Features/admin/dashboard/dashboard.component';
import { ConfirmationDialogComponent } from './Core/components/confirmation-dialog/confirmation-dialog.component';
import { CombinedUserDevicesComponent } from './Features/admin/admin-module/combined-user-devices/combined-user-devices.component';
import { TestConsentDialogComponent } from './Core/components/test-consent-dialog/test-consent-dialog.component';
import { UploadImageComponentComponent } from './Core/components/upload-image-component/upload-image-component.component';
import { ImagePreviewComponent } from './Core/components/upload-image-component/image-preview/image-preview.component';
import { PhotoUploadComponent } from './Core/components/upload-image-component/photo-upload/photo-upload.component';
import { UpdateImageComponent } from './Core/components/upload-image-component/update-image/update-image.component';
import { ConfirmSwitchDialogComponent } from './Core/components/confirm-switch-dialog/confirm-switch-dialog.component';
import { ImageDetailsComponent } from './Core/components/upload-image-component/image-details/image-details.component';
import { PushNotificationComponent } from './Core/components/push-notification/push-notification.component';
import { NotificationListComponent } from './Core/components/push-notification/notification-list/notification-list.component';
import { TestNotificationComponent } from './Core/components/push-notification/test-notification/test-notification.component';
import { AccessRestrictionDialogComponent } from './Core/components/access-restriction-dialog/access-restriction-dialog.component';
import { EditNotificationComponent } from './Core/components/push-notification/edit-notification/edit-notification.component';
import { DeviceLogsComponent } from './Core/components/device-logs/device-logs/device-logs.component';
import { ViewDialogComponent } from './Core/components/device-logs/view-dialog/view-dialog.component';
import { AuthGuard } from './auth.guard';
import { DeviceTypeComponent } from './Core/components/Layout/Panel/device-type/device-type.component';
import { IaqSubscriptionsComponent } from './Core/components/Layout/Panel/iaq-subscriptions/iaq-subscriptions.component';
import { SubscriptionDeferComponent } from './Core/components/Layout/Panel/subscription-defer/subscription-defer.component';
import { IaqChartsComponent } from './Core/components/iaq-charts/iaq-charts.component';
import { ChartComponent } from './Core/components/chart/chart.component';
import { ChartFullscreenComponent } from './Core/components/chart-fullscreen/chart-fullscreen.component';
import { ForceUpgradeComponent } from './Features/admin/admin-module/force-upgrade/force-upgrade.component';
import { OtaDashboardComponent } from './Features/admin/admin-module/ota-dashboard/ota-dashboard.component';
import { CreateOtaJobComponent } from './Features/admin/admin-module/create-ota-job/create-ota-job.component';
import { OtaDetailComponent } from './Features/admin/admin-module/ota-detail/ota-detail.component';
import { OtaDeviceKeyComponent } from './Features/admin/admin-module/ota-device-key/ota-device-key.component';
import { OtaModelSelectionDialogComponent } from './Features/admin/admin-module/ota-model-selection-dialog/ota-model-selection-dialog.component';



const routes:Routes=[
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {path: 'login', component:LoginComponent},
  {path: 'change-password', component:ChangePasswordComponent},
  {path: 'user', component: UserSearchComponent, canActivate: [AuthGuard]},
  {path: 'devices',component: DeviceListComponent, canActivate: [AuthGuard] },
  {path: 'alerts',component: AlertCtlComponent, canActivate: [AuthGuard]},
  {path: 'logs',component:LogComponent, canActivate: [AuthGuard]},
  { path: 'user-detail/:id', component: UserDetailComponent, canActivate: [AuthGuard] },
  { path: 'user-info/:id', component: UserInfoAllComponent},
  {path:'userpage',component: UserDetailsDisplayComponent, canActivate: [AuthGuard]},
  {path: 'device-details/locationId/:locationId/device/:id',component: DeviceDetailCtlComponent, canActivate: [AuthGuard]},
  {path: 'working', component:DeviceDynamicComponent, canActivate: [AuthGuard]},
  {path: 'location/:id',component:FirmwareComponentComponent, canActivate: [AuthGuard]},
  {path: 'OTA-upgrade',component: OtaModuleComponent, canActivate: [AuthGuard]},
  {path: 'OTA-upgrade/:id',component:OTAJobDetailComponent, canActivate: [AuthGuard]},
  {path: 'dashboard', component:DashboardComponent, canActivate: [AuthGuard]},
  {path: 'services', redirectTo: 'services/User', pathMatch: 'full' },
  {path: 'services/:serviceType', component:CombinedUserDevicesComponent, canActivate: [AuthGuard]},
  {path: 'upload/:imageType/:language',component: UploadImageComponentComponent, canActivate: [AuthGuard]},
  {path: 'upload', redirectTo: 'upload/explorer/en', pathMatch: 'full'},
  {path: 'photo-upload', component:PhotoUploadComponent, canActivate: [AuthGuard]},
  {path: 'image-preview', component:ImagePreviewComponent, canActivate: [AuthGuard]},
  {path: 'update-image', component:UpdateImageComponent, canActivate: [AuthGuard]},
  {path: 'image-details', component:ImageDetailsComponent, canActivate: [AuthGuard]},
  {path: 'notification-list', component:NotificationListComponent, canActivate: [AuthGuard]},
  {path: 'notification', component:PushNotificationComponent, canActivate: [AuthGuard]},
  {path: 'test-notification', component:TestNotificationComponent, canActivate: [AuthGuard]},
  {path: 'edit-notification',component:EditNotificationComponent, canActivate: [AuthGuard]},
  {path: 'device-logs',component:DeviceLogsComponent, canActivate: [AuthGuard]},
  {path: 'subscription-history/:id',component: IaqSubscriptionsComponent, canActivate: [AuthGuard]},
  {path: 'chart-fullscreen', component: ChartFullscreenComponent, canActivate: [AuthGuard]},
  {path: 'force-upgrade',component: ForceUpgradeComponent, canActivate: [AuthGuard]},
  {path: 'ota-dashboard',component: OtaDashboardComponent, canActivate: [AuthGuard]},
  {path: 'create-ota-job',component: CreateOtaJobComponent, canActivate: [AuthGuard]},
  {path: 'ota-device-key',component: OtaDeviceKeyComponent, canActivate: [AuthGuard]},
  ];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    YesNoPipe,
    HumanTimePipe,
    TimeFormatPipe,
    GeoSizePipe,
    CamLightPipe,
    WeatherFilterPipe,
    DashboardComponent,
    UserSearchComponent,
    UserDetailComponent,
    DeviceDetailCtlComponent,
    DeviceListComponent,
    LogComponent,
    LocationDetailComponent,
    AlertCtlComponent,
    HumanTimeComponent,
    EnterKeyComponent,
    ToolbarComponent,
    UserStatsComponent,
    DeviceConnectivityStatusComponent,
    WifiDetectorsComponent,
    CamerasComponent,
    HubsComponent,
    TimeZoneHoverComponent,
    UserInfoAllComponent,
    LocationDisplayComponent,
    DevicesDisplayComponent,
    UserDetailsDisplayComponent,
    ChangePasswordComponent,
    FirmwareComponentComponent,
    LocationComponentComponent,
    DeviceDynamicComponent,
    KeysPipe,
    MembersPanelComponent,
    OtaModuleComponent,
    ListOTAComponent,
    OTAJobDetailComponent,
    SuccessDialogComponent,
    SpinnerComponent,
    LoadingDialogComponent,
    DashboardComponent,
    ConfirmationDialogComponent,
    CombinedUserDevicesComponent,
    TestConsentDialogComponent,
    UploadImageComponentComponent,
    ImagePreviewComponent,
    PhotoUploadComponent,
    UpdateImageComponent,
    ConfirmSwitchDialogComponent,
    ImageDetailsComponent,
    PushNotificationComponent,
    NotificationListComponent,
    TestNotificationComponent,
    AccessRestrictionDialogComponent,
    EditNotificationComponent,
    DeviceLogsComponent,
    ViewDialogComponent,
    DeviceTypeComponent,
    IaqSubscriptionsComponent,
    SubscriptionDeferComponent,
    IaqChartsComponent,
    ChartComponent,
    ChartFullscreenComponent,
    ForceUpgradeComponent,
    OtaDashboardComponent,
    CreateOtaJobComponent,
    OtaDetailComponent,
    OtaDeviceKeyComponent,
    OtaModelSelectionDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    //AppRoutingModule,
    HttpClientModule,
    RouterModule.forRoot(routes),
    MatTooltipModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatSnackBarModule,
    MatDividerModule,
    GoogleChartsModule,
    ReactiveFormsModule,
    FormsModule,
    AgGridModule,
    NgbModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    LoadingBarModule,
    LoadingBarHttpClientModule,
    MatMenuModule,
    MatRadioModule,
    MatDialogModule,
    MaterialFileInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    NgxTrimDirectiveModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ImageCropperComponent,
    DragDropModule,
    ChartModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass :AuthInterceptor,
      multi:true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass :AuthenticationInterceptor,
      multi:true
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: true, panelClass: 'app-dialog-container' },
    },
    ApiService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
